var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"animationvisualizer"}},[_c('lottie',{staticClass:"animationvisualizer",attrs:{"options":_vm.defaultOptions,"autoplay":true,"loop":true,"height":100,"width":100},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }